import React, { useContext, useState } from "react";

import { useAppStore } from "../../../../../context/store";
import {
  Dialog,
  Portal,
  SimpleGrid,
  Select,
  Field,
  ColorPicker,
  parseColor,
  NumberInput,
  HStack,
  CloseButton,
  Button,
  useSelectContext,
  VStack,
  Input,
  createListCollection,
  Checkbox,
  Image,
} from "@chakra-ui/react";

import { capitalizeFirstLetter, createFillPattern, getDataSourceGeometryType, removeFileExtension, rgbaToHex } from "../../../../../utilies/Utility";
import { useEffect } from "react";
import { updateEntityStyle } from "../../../../../utilies/GeojsonUtility";
import { useMapObjects } from "../../../../../context/MapObjectsContext";
const LayersStyleDialog = () => {
  // state
  const showStyleDialog = useAppStore((s) => s.showStyleDialog);
  const currentLayer = useAppStore((s) => s.currentLayer);
 const { mapObjects, setMapObjects, mapObjectsRef } = useMapObjects();

  // setters
  const setShowStyleDialog = useAppStore.getState().setShowStyleDialog;
  const setCurrentLayer = useAppStore.getState().setCurrentLayer;
 

  const [typeOfGeojson, setTypeOfGeojson] = useState("none");
  const [styleWidth, setStyleWidth] = useState(2);
  const [styleColor, setStyleColor] = useState("#ffffff");
  const [styleInsideColor, setStyleInsideColor] = useState("#ffffff");
  const [styleType, setStyleType] = useState("Solid");
  const [sytlePattern, setSytlePattern] = useState("1111111111111111");
  const [styleInvisibleByDefault, setStyleInvisibleByDefault] = useState(false);

  const [stylePolygonPattern, setStylePolygonPattern] = useState("");

  const styleTypeOption = createListCollection({
    items: [
      {
        name: "Solid",
      },
      {
        name: "Dashed",
      },
      {
        name: "Dotted",
      },
      {
        name: "Pattern",
      },
    ],
    itemToString: (item) => item.name,
    itemToValue: (item) => item.name,
  });

  const stylePatternsOption = createListCollection({
    items: [
      {
        name: "No Pattern",
        url: "",
      },
      {
        name: "Pattern 1",
        url: "/patterns/pattern1.svg",
      },
      {
        name: "Pattern 2",
        url: "/patterns/pattern2.svg",
      },
      {
        name: "Pattern 3",
        url: "/patterns/pattern3.svg",
      },
      {
        name: "Pattern 4",
        url: "/patterns/pattern4.svg",
      },
    ],
    itemToString: (item) => item.name,
    itemToValue: (item) => item.url,
  });

  const TypeSelectValue = () => {
    const select = useSelectContext();
    const items = select.selectedItems;
    if (items.length !== 0) {
      const { name } = items[0];
      return (
        <Select.ValueText placeholder="Select member">
          <HStack>{name}</HStack>
        </Select.ValueText>
      );
    }
  };

  useEffect(() => {
    if (showStyleDialog) {
      setTypeOfGeojson(getDataSourceGeometryType(currentLayer.dataSource));
      currentLayer.style_stroke_width ? setStyleWidth(currentLayer.style_stroke_width) : setStyleWidth(2);
      currentLayer.style_pattern ? setSytlePattern(currentLayer.style_pattern) : setSytlePattern("1111111111111111");
      currentLayer.style_outline_color ? setStyleColor(currentLayer.style_outline_color) : setStyleColor("#ffffff");
      currentLayer.style_fill_color ? setStyleInsideColor(currentLayer.style_fill_color) : setStyleInsideColor("#ffffff");
      currentLayer.style_type ? setStyleType(capitalizeFirstLetter(currentLayer.style_type)) : setStyleType("Solid");
      currentLayer.style_fill_pattern ? setStylePolygonPattern(currentLayer.style_fill_pattern) : setStylePolygonPattern("");
      setStyleInvisibleByDefault(currentLayer?.style_invisible_default == true ? true : false);
    }
  }, [showStyleDialog, currentLayer]);

  return (
    <Dialog.Root
      lazyMount
      open={showStyleDialog}
      onOpenChange={(e) => {
        setShowStyleDialog(e.open);
        if (!Boolean(e.open)) {
          setCurrentLayer(null);
        }
      }}
      closeOnInteractOutside={false}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <VStack align={"left"} spacing={0}>
                <Dialog.Title>Styles</Dialog.Title>
                <Dialog.Description lineClamp={1}>{currentLayer ? "Layer: " + removeFileExtension(currentLayer.file_name) : ""}</Dialog.Description>
              </VStack>
            </Dialog.Header>
            <Dialog.Body>
              <SimpleGrid columns={2} gap={5}>
                {typeOfGeojson == "line" && (
                  <>
                    <Select.Root
                      collection={styleTypeOption}
                      size="sm"
                      defaultValue={[styleType]}
                      positioning={{ sameWidth: true }}
                      onValueChange={(v) => {
                        setStyleType(v.value[0]);
                      }}
                    >
                      <Select.HiddenSelect />
                      <Select.Label>Type</Select.Label>
                      <Select.Control>
                        <Select.Trigger>
                          <TypeSelectValue />
                        </Select.Trigger>
                        <Select.IndicatorGroup>
                          <Select.Indicator />
                        </Select.IndicatorGroup>
                      </Select.Control>
                      <Select.Positioner>
                        <Select.Content>
                          {styleTypeOption.items.map((item) => (
                            <Select.Item item={item} key={item.name} justifyContent="flex-start">
                              {item.name}
                              <Select.ItemIndicator />
                            </Select.Item>
                          ))}
                        </Select.Content>
                      </Select.Positioner>
                    </Select.Root>
                    {styleType == "Pattern" && (
                      <Field.Root>
                        <Field.Label>Pattern</Field.Label>
                        <Input
                          maxLength={16}
                          minLength={16}
                          width={"full"}
                          size={"sm"}
                          value={sytlePattern}
                          onChange={(v) => {
                            setSytlePattern(v.target.value);
                          }}
                        />
                      </Field.Root>
                    )}
                  </>
                )}

                {["line", "point"].includes(typeOfGeojson) && (
                  <Field.Root>
                    <Field.Label>Stroke Width</Field.Label>
                    <NumberInput.Root
                      defaultValue="2"
                      width={"full"}
                      size={"sm"}
                      value={styleWidth}
                      onValueChange={(v) => {
                        setStyleWidth(v.valueAsNumber ? v.valueAsNumber : 1);
                      }}
                    >
                      <NumberInput.Control />
                      <NumberInput.Input />
                    </NumberInput.Root>
                    <Field.ErrorText>The entry is invalid</Field.ErrorText>
                  </Field.Root>
                )}

                {["line", "point", "polygon"].includes(typeOfGeojson) && (
                  <ColorPicker.Root
                    defaultValue={parseColor(styleColor)}
                    width={"full"}
                    onValueChange={(v) => {
                      setStyleColor(rgbaToHex(v.valueAsString));
                    }}
                  >
                    <ColorPicker.HiddenInput />
                    <ColorPicker.Label>Outline Color</ColorPicker.Label>
                    <ColorPicker.Control>
                      <ColorPicker.Input />
                      <ColorPicker.Trigger />
                    </ColorPicker.Control>

                    <ColorPicker.Positioner>
                      <ColorPicker.Content>
                        <ColorPicker.Area />
                        <HStack>
                          <ColorPicker.EyeDropper size="xs" variant="outline" />
                          <ColorPicker.Sliders />
                        </HStack>
                      </ColorPicker.Content>
                    </ColorPicker.Positioner>
                  </ColorPicker.Root>
                )}

                {["polygon", "point"].includes(typeOfGeojson) && (
                  <ColorPicker.Root
                    defaultValue={parseColor(styleInsideColor)}
                    width={"full"}
                    onValueChange={(v) => {
                      setStyleInsideColor(rgbaToHex(v.valueAsString));
                    }}
                  >
                    <ColorPicker.HiddenInput />
                    <ColorPicker.Label>Fill Color</ColorPicker.Label>
                    <ColorPicker.Control>
                      <ColorPicker.Input />
                      <ColorPicker.Trigger />
                    </ColorPicker.Control>

                    <ColorPicker.Positioner>
                      <ColorPicker.Content>
                        <ColorPicker.Area />
                        <HStack>
                          <ColorPicker.EyeDropper size="xs" variant="outline" />
                          <ColorPicker.Sliders />
                        </HStack>
                      </ColorPicker.Content>
                    </ColorPicker.Positioner>
                  </ColorPicker.Root>
                )}

                {["polygon"].includes(typeOfGeojson) && (
                  <Select.Root
                    collection={stylePatternsOption}
                    size="sm"
                    defaultValue={[stylePolygonPattern]}
                    positioning={{ sameWidth: true }}
                    onValueChange={(v) => {
                      setStylePolygonPattern(v.value[0]);
                    }}
                  >
                    <Select.HiddenSelect />
                    <Select.Label>Fill Pattern</Select.Label>
                    <Select.Control>
                      <Select.Trigger>
                        <TypeSelectValue />
                      </Select.Trigger>
                      <Select.IndicatorGroup>
                        <Select.Indicator />
                      </Select.IndicatorGroup>
                    </Select.Control>
                    <Select.Positioner>
                      <Select.Content>
                        {stylePatternsOption.items.map((item) => (
                          <Select.Item item={item} key={item.name} justifyContent="flex-start">
                            {item.url && <Image src={item.url} />}
                            {item.name}
                            <Select.ItemIndicator />
                          </Select.Item>
                        ))}
                      </Select.Content>
                    </Select.Positioner>
                  </Select.Root>
                )}
              </SimpleGrid>
              <Checkbox.Root
                mt={3}
                checked={styleInvisibleByDefault}
                onCheckedChange={(v) => {
                  setStyleInvisibleByDefault(v.checked);
                }}
              >
                <Checkbox.HiddenInput />
                <Checkbox.Control />
                <Checkbox.Label>Invisible by default</Checkbox.Label>
              </Checkbox.Root>
            </Dialog.Body>
            <Dialog.Footer>
              <Dialog.ActionTrigger asChild>
                <Button variant="outline">Cancel</Button>
              </Dialog.ActionTrigger>
              <Button
                onClick={async () => {
                  const dataSource = currentLayer.dataSource;

                  if (dataSource) {
                    updateEntityStyle(
                      dataSource,
                      styleWidth,
                      styleColor,
                      styleInsideColor,
                      styleType,
                      sytlePattern,
                      [mapObjects, setMapObjects],
                      currentLayer.id,
                      typeOfGeojson,
                      await createFillPattern(stylePolygonPattern, styleInsideColor),
                      stylePolygonPattern,
                      styleInvisibleByDefault,
                    );
                  }
                }}
              >
                Apply
              </Button>
              <Button
                onClick={async () => {
                  const dataSource = currentLayer.dataSource;

                  if (dataSource) {
                    updateEntityStyle(
                      dataSource,
                      styleWidth,
                      styleColor,
                      styleInsideColor,
                      styleType,
                      sytlePattern,
                      [mapObjects, setMapObjects],
                      currentLayer.id,
                      typeOfGeojson,
                      await createFillPattern(stylePolygonPattern, styleInsideColor),
                      stylePolygonPattern,
                      styleInvisibleByDefault,
                    );
                  }
                  setShowStyleDialog(false);
                }}
              >
                Update
              </Button>
            </Dialog.Footer>
            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default LayersStyleDialog;
